export default __webpack_public_path__ + "d1afb5bf600c5d86330567e96fa6ff2e.svg";